








































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { ProductIssueDetailsModule } from '@/store/Products/ProductIssueDetailsModule';
import AccountState from '@/components/Accounts/Shared/AccountState.vue';

@Component({ name: 'ProductIssueAccounts', components: { AccountState } })
export default class extends SaascadaVue {

    headers = [
        { text: this.$t('pageText.productIssues.fields.name'), sortable: false, width: '40%' },
        { text: this.$t('pageText.productIssues.fields.product'), sortable: false, width: '30%' },
        { text: this.$t('pageText.productIssues.fields.createdAt'), sortable: false, width: '20%' },
        { text: this.$t('pageText.productIssues.fields.state'), sortable: false, width: '10%' },
    ];
    productIssueAccountsPage = 1;

    async created() {
        // Check for page number in URL parameters
        const page = this.$route.query.page;
        if (page) {
            this.productIssueAccountsPage = +page;
        }
    }

    async beforeMount() {
        await ProductIssueDetailsModule.getProductIssueAccounts(this.productIssueAccountsPage);
    }

    @Watch('productIssueAccountsPage')
    async onProductIssueAccountsPageChanged() {
        // Update route with tab and page number (if it has changed)
        if (this.productIssueAccountsPage !== +this.$route.query.page) {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `${this.$route.query.tab}`, page: `${this.productIssueAccountsPage}` } });
        }
        // Get new product issue accounts
        await ProductIssueDetailsModule.getProductIssueAccounts(this.productIssueAccountsPage);
    }

    get productsIssueAccounts() {
        return ProductIssueDetailsModule.productIssueAccounts;
    }

    get totalProductIssueAccountsPages() {
        return ProductIssueDetailsModule.totalProductIssueAccountsPages;
    }

    get loading() {
        return ProductIssueDetailsModule.loading;
    }

    get pageSize() {
        return ProductIssueDetailsModule.pageSize;
    }

}
